// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__9Uq8q","info":"Note_info__2ZcJk","note":"Note_note__3SasH","actions":"Note_actions__3A8_u"};